import React from 'react';
import moment from 'moment';
import Typography from '@src/new-components/Typography';
import { useTranslation } from 'react-i18next';
import { SUB_STATUS } from '@src/constants/voiceCloning';
import { COLOR } from '@src/styles/color';
import RunningWithErrorsRoundedIcon from '@mui/icons-material/RunningWithErrorsRounded';
import Tooltip from '@src/components/Tooltip';
import { convertFormatDate } from '@src/utils/date';

import { StyledWaitingForRemovalTag } from './index.style';

const WaitingForRemovalTag = ({ subStatus, discardAt }) => {
  const { t } = useTranslation();

  if (subStatus !== SUB_STATUS.WAITING_FOR_REMOVAL) return null;

  const daysLeftBeforeVoiceCloningDiscard = moment(discardAt).diff(
    moment(),
    'days',
  );

  const contentTooltip = (
    <Typography sx={{ fontSize: '14px' }}>
      {t('myVoiceCloningDiscardAt', {
        date: convertFormatDate(discardAt),
      })}
    </Typography>
  );

  return (
    <Tooltip
      disableInteractive={!contentTooltip}
      disableTouchListener={!contentTooltip}
      arrow
      title={contentTooltip || ''}
      placement="top"
      textAlign="center"
    >
      <StyledWaitingForRemovalTag>
        <RunningWithErrorsRoundedIcon
          sx={{
            color: COLOR.functionalRed.default,
            fontSize: 16,
          }}
        />
        <Typography
          variant="body-12-medium"
          color={COLOR.functionalRed.default}
        >
          {t(daysLeftBeforeVoiceCloningDiscard ? 'dayNumber' : 'today', {
            days: daysLeftBeforeVoiceCloningDiscard,
          })}
        </Typography>
      </StyledWaitingForRemovalTag>
    </Tooltip>
  );
};

export default WaitingForRemovalTag;
